export default __webpack_public_path__ + "static/media/M3TRIKFOOTER.b24ba98f.png";